import axios from "axios";
import { getRequestedCountForBulk } from "./bulkPlacementBidUpdate";

export { getRequestedCountForBulk };

export const CAMPAIGN_BULK_FIELD = {
  DAILY_BUDGET: "DAILY_BUDGET",
  STATUS: "STATUS",
  BID_STRATEGY: "BID_STRATEGY",
};

export const BID_STRATEGY_LABEL = {
  DOWN: "Down",
  UP_AND_DOWN: "Up & Down",
};

/** Normalize API / UI bid strategy values to UI labels sent to bulk API. */
export function normalizeBidStrategyLabel(value) {
  const raw = String(value ?? "").trim();
  const lower = raw.toLowerCase();
  if (!raw) return BID_STRATEGY_LABEL.DOWN;
  if (
    lower.includes("up") ||
    lower === "autoforsales" ||
    raw === BID_STRATEGY_LABEL.UP_AND_DOWN
  ) {
    return BID_STRATEGY_LABEL.UP_AND_DOWN;
  }
  return BID_STRATEGY_LABEL.DOWN;
}

export function dedupeRowsByCampaignId(rows = []) {
  const seen = new Set();
  const result = [];
  (rows || []).forEach((row) => {
    const id = row?.campaign_id != null ? String(row.campaign_id) : "";
    if (!id || seen.has(id)) return;
    seen.add(id);
    result.push(row);
  });
  return result;
}

export function getUniqueCampaignCount(rows = []) {
  return dedupeRowsByCampaignId(rows).length;
}

/**
 * Body for PATCH .../campaigns:bulk-patch-update-campaign
 * operation examples:
 *  { field: "DAILY_BUDGET", adjustmentType, value }
 *  { field: "BID_STRATEGY", strategy: "Up & Down" | "Down" }
 *  { field: "STATUS", adjustmentType: "ENABLE" | "PAUSE" }
 */
export function buildBulkCampaignPatchBody({
  query,
  email,
  requestedCount,
  operation,
}) {
  return {
    filters: {
      query: { ...(query || {}) },
    },
    operation: { ...(operation || {}) },
    email: email || "",
    requestedCount: Number(requestedCount) || 0,
  };
}

export async function submitBulkCampaignPatchUpdate({
  clientId,
  userPlatform = "amazon",
  skipEvents = true,
  body,
  token,
}) {
  const baseUrl = process.env.REACT_APP_ADS_API;
  const url = `${baseUrl}/client/${clientId}/campaigns:bulk-patch-update-campaign?skipEvents=${
    skipEvents ? "true" : "false"
  }&source=${userPlatform}`;

  const headers = {
    "Content-Type": "application/json",
  };
  if (token) headers.Authorization = token;

  const response = await axios.patch(url, body, { headers });
  return response?.data;
}
